/* unplugin-vue-components disabled */import script from "./WhiteTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhiteTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./WhiteTableBlock.vue?vue&type=style&index=0&id=68880916&scoped=true&lang=less"
import "./WhiteTableBlock.vue?vue&type=style&index=1&id=68880916&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68880916"]])

export default __exports__